export const visionDocuments = [
    {
        type: 'text', 
        question_no: 'field1', 
        question: 'What is your vision/purpose statement?', 
        description: 'A vision statement should be no more than one sentence. It should not be more than 20-25 words. It should be simple enough for every employee across all levels to express it easily. It is the end result of your organizations work. If your organization were to work for 30-35 years, what would you visualize as the final state of affairs? Every time you say the vision, you should be able to visualize the end situation. It is the final picture/photo of the situation in your chosen theme or area of work in the end! It is a description of the "after" picture you would see as a result of your organizations work at the end of its lifetime when you believe its purpose is accomplished.', 
        depend_question: 'field0', 
        condition: 'equals', 
        value: 'yes', 
        validation:'textarea', 
        options: []
        , 
        mandatory: 0,
      },
]


export const MissionDocuments = [
    {
        type: 'text', 
        question_no: 'field1', 
        question: 'What is your mission statement?', 
        description: "This section shows the 'What we do' statement from the Discover Registration Details section. If you want to check or update this statement, click the button below.", 
        depend_question: 'field0', 
        condition: 'equals', 
        value: 'yes', 
        validation:'textarea', 
        options: []
        , 
        mandatory: 0,
      },
]

export const StrategyAndGoalDocuments = [
    {
        type: 'text', 
        question_no: 'field1', 
        question: "What are your organisation's overall objectives for the next 3 to 5 years?", 
        description: "Clearly and concisely state your organisation’s ultimate goal for intended impact. Identify the groups or communities you aim to assist, the needs your work is addressing, and your expected outcomes. Are your goals for the next three to five years fitting within your overall plan to contribute to lasting, meaningful change?", 
        depend_question: 'field0', 
        condition: 'equals', 
        value: 'yes', 
        validation:'textarea', 
        options: []
        , 
        mandatory: 0,
      },
    {
        type: 'text', 
        question_no: 'field2', 
        question: "Describe your organisation’s strategies for achieving the goals you cited.", 
        description: "Specify the broad approaches you employ and why your organization believes these methods will benefit your target audience or advance your issue. Lay out near-term activities that serve as important building blocks for future success, explaining how these elements strengthen your organizations strategic approach.", 
        depend_question: 'field1', 
        condition: 'equals', 
        value: 'yes', 
        validation:'textarea', 
        options: []
        , 
        mandatory: 0,
      },
]